export const sizes = {
    // Multiples of 4 up to 20px with some exceptions, multiples of 8 beyond with no exceptions.
    '0': '0px',
    '0.25': '1px',
    '0.5': '2px',
    '1': '4px',
    '2': '8px',
    '3': '12px',
    '3.5': '14px',
    '4': '16px',
    '5': '20px',
    '6': '24px',
    '8': '32px',
    '10': '40px',
    '12': '48px',
    '14': '56px',
    '16': '64px',
    '18': '72px',
    '20': '80px',
    '24': '96px',
    '30': '120px',
    '40': '160px',
    '50': '200px',
};
